import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TextTemplateTypeModel } from 'src/app/models/text-templates/text-template-type.model';
import { UserContextService } from 'src/app/services/user-context.service';

@Component({
  selector: 'app-training-start-date-changed-notification-dialog',
  standalone: false,
  templateUrl: './training-start-date-changed-notification-dialog.component.html',
  styleUrl: './training-start-date-changed-notification-dialog.component.scss',
})
export class TrainingStartDateChangedNotificationDialogComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() submit = new EventEmitter();

  textTemplateType: TextTemplateTypeModel = 
    TextTemplateTypeModel.ChangeMeeting;
  
  formData = {
    infoInput: '',
    infoCheckbox: false,
  };

  constructor(
    public userContext: UserContextService
  ) {}
  

  dismiss = () => {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  };

  onSubmit = () => {
    const result: TrainingStartDateChangedNotificationResult = {
      notifyAcceptedMembers: this.formData.infoCheckbox,
      notificationInformationText: this.formData.infoCheckbox
        ? this.formData.infoInput
        : null,
    };
    this.submit.emit(result);
  };

  onTemplateContentChanged(content: string) {
    this.formData.infoInput = content;
  }
}

export interface TrainingStartDateChangedNotificationResult {
  notifyAcceptedMembers: boolean;
  notificationInformationText: string | null;
}
